import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import type { StudioClient } from "../schema";

export interface ClientSlideProps {
  client: StudioClient;
}

export default function ClientSlide({ client }: ClientSlideProps) {
  const [current, setCurrent] = useState(0);
  const images = client.imgSrcs ?? [];

  useEffect(() => {
    if (images.length === 0) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [images]);

  return (
    <>
      {images.length >= 1 ? (
        <div
          className="min-w-full grid grid-cols-4 grid-rows-8 lg:grid-rows-1 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-12 gap-y-6 gap-x-4 md:gap-6 xl:gap-8 xl:px-30 pb-12 pt-5 xl:py-30"
          style={{ scrollSnapAlign: "start" }}
        >
          <div className="col-span-full lg:col-span-5 xl:col-span-8 aspect-video self-center flex items-center justify-center relative overflow-hidden w-full row-span-7 lg:row-span-1">
            <AnimatePresence mode="wait">
              <motion.img
                key={current}
                src={images[current]}
                alt={client.name ?? "Client image"}
                className="w-full h-full aspect-video absolute top-0 left-0 lg:max-h-98"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
                width={1920}
                height={1080}
              />
            </AnimatePresence>
          </div>

          <div className="row-start-1 lg:row-start-auto lg:col-span-3 xl:col-span-4 flex items-center justify-center px-8">
            <div className="flex flex-col gap-2">
              <h5 className="font-semibold font-xExpandedBold text-lg md:text-base lg:text-3xl 3xl:text-5xl">
                {client.name}
              </h5>
              <p>{client.desc}</p>
            </div>
          </div>
        </div>
      ) : (
        <div className="min-w-full grid place-items-center py-12">
          <p>No images available</p>
        </div>
      )}
    </>
  );
}
